import { ReaderState, ColorMode, Marker, BLACK_CHAR_CODE } from './constants';

export class SixelReader {
  constructor() {
    this.index = 0;
    this.colorRegisters = {};
    this.caretMovements = {};
    this.colors = [];
    this.sixels = [];

    this.readerState = ReaderState.INITIAL;
    this._number = 0;
  }

  /**
   *
   * @param {String} str
   */
  setString(str) {
    this.sixelStr = str;
  }

  readConfig() {
    const lastSemiIndex = this.sixelStr.lastIndexOf(';');
    const lastHashIndex = this.sixelStr.indexOf('#', lastSemiIndex);

    this.index = lastHashIndex - 1;

    const chunks = this.sixelStr
      .slice(0, lastHashIndex)
      .replace('Pq"', '')
      .split('#');

    const [dimensions, ...colors] = chunks;

    const [xRatio, yRatio, width, height] = dimensions.split(';');

    // TODO: handle ratio

    this.size = {
      width: +width,
      height: +height,
    };

    this.colorRegisters = colors.reduce((colors, chunk) => {
      const [index, colorMode, r, g, b] = chunk.split(';');

      if (colorMode !== ColorMode.RGB) {
        throw new Error('Unknonw color mode');
      }

      colors[+index] = {
        r: ((+r / 100) * 255) | 0,
        g: ((+g / 100) * 255) | 0,
        b: ((+b / 100) * 255) | 0,
      };

      return colors;
    }, {});

    this.readerState = ReaderState.CONFIG_PARSED;
  }

  readSixels(onSixel, onCaretMove) {
    const maxIndex = this.sixelStr.length - 1;

    for (var i = 0; i < maxIndex; i++) {
      const nextChar = this.sixelStr.charAt(i);
      const nextCharCode = nextChar.charCodeAt(0);

      if (this.readerState === ReaderState.READING_NUMBER && (nextCharCode < 48 || nextCharCode > 57)) {
        if (!this._shouldRepeat) {
          this.activeColorRegister = this._number;
          this._number = 0;
        }
        this.readerState = ReaderState.READING_SIXEL;
      }

      if (nextCharCode === Marker.CR || nextCharCode === Marker.LF) {
        onCaretMove(nextCharCode);
        continue;
      }

      if (nextCharCode === Marker.NUMBER) {
        this.readerState = ReaderState.READING_NUMBER;
        this._number = 0;
        continue;
      }

      if (this.readerState === ReaderState.READING_NUMBER) {
        this._number *= 10;
        this._number += nextCharCode - 48;
        continue;
      }

      if (nextCharCode === Marker.REPEAT) {
        this._shouldRepeat = true;
        this.readerState = ReaderState.READING_NUMBER;
        continue;
      }

      if (this.readerState === ReaderState.READING_SIXEL) {
        this._handleSixel(nextCharCode - BLACK_CHAR_CODE, onSixel);
        continue;
      }
    }
  }

  _handleSixel(decodedSixel, onSixel) {
    // TODO: handle this properly
    if (decodedSixel < 0) {
      return;
    }

    if (this._shouldRepeat) {
      this._shouldRepeat = false;

      for (let i = 0; i < this._number; i++) {
        onSixel(decodedSixel, this.colorRegisters[this.activeColorRegister]);
      }

      this._number = 0;
    } else {
      onSixel(decodedSixel, this.colorRegisters[this.activeColorRegister]);
    }
  }
}
